import React, {useCallback, useEffect, useState} from 'react';
import SentenceForm from "../../components/common/SentenceForm";
import Container from "@material-ui/core/Container";
import {makeStyles} from "@material-ui/core";
import ScrollableAnchor from "react-scrollable-anchor";
import Radio from "@material-ui/core/Radio";
import clsx from "clsx";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import RadioGroup from "@material-ui/core/RadioGroup";
import {useRecoilState, useRecoilValue, useSetRecoilState} from "recoil";
import {
    answerState,
    menuCheckSelector,
    selectedMenuItemState,
    surveyDataState,
    userState
} from "../../state/globalState";

const useStyles = makeStyles(theme => ({
    root: {
        '&:hover': {
            backgroundColor: 'transparent',
        },
    },
    buttons: {
        display: 'flex',
        justifyContent: 'flex-end'
    },
    button: {
        marginTop: theme.spacing(3),
        marginLeft: theme.spacing(1),
    },
    icon: {
        borderRadius: '50%',
        width: 16,
        height: 16,
        boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
        backgroundColor: '#f5f8fa',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
        '$root.Mui-focusVisible &': {
            outline: '2px auto rgba(19,124,189,.6)',
            outlineOffset: 2,
        },
        'input:hover ~ &': {
            backgroundColor: '#ebf1f5',
        },
        'input:disabled ~ &': {
            boxShadow: 'none',
            background: 'rgba(206,217,224,.5)',
        },
    },
    checkedIcon: {
        backgroundColor: '#1b6817',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
        '&:before': {
            display: 'block',
            width: 16,
            height: 16,
            backgroundImage: 'radial-gradient(#fff,#fff 28%,transparent 32%)',
            content: '""',
        },
        'input:hover ~ &': {
            backgroundColor: '#1b6817',
        },
    },
    textField: {
        width: '300px'
    },
    textFieldMobile: {
        width: '250px'
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
    },
    date: {
        width: "160px",
        padding: "8px",
        margin: "10px 0"
    }
}));

/**
 * 설문 문항 컴포넌트
 */
const Survey2 = (props) => {
    const userInfo = useRecoilValue(userState);
    const surveyData = useRecoilValue(surveyDataState);
    const [answer, setAnswer] = useRecoilState(answerState);
    const setSelectedMenuItem = useSetRecoilState(selectedMenuItemState);
    const setMenuCheck = useSetRecoilState(menuCheckSelector);
    const [visible, setVisible] = useState(!surveyData[116].hasOwnProperty('visible'));
    const [visibled02, setVisible02] = useState(!surveyData[125].hasOwnProperty('visible'));
    const classes = useStyles();
    const {divorceDt, divorceYn} = answer;

    useEffect(()=>{
        if(surveyData[116].hasOwnProperty('visible')){
            const visibleConditon = surveyData[116].visible;
            if(visibleConditon.value.includes(answer[visibleConditon.column]) ){
                setVisible(true);
            }
            else{
                setVisible(false);
            }
        }

      if(surveyData[125].hasOwnProperty('visible')){
        const visibleConditon = surveyData[125].visible;
        if(visibleConditon.value.includes(answer[visibleConditon.column]) ){
          setVisible02(true);
        }
        else{
          setVisible02(false);
        }
      }
    }, [answer])


    const handleInputAnswer = (e, column) => {
        const { value, name } = e.target;
        let key = null

        if ("spouse" === column) {
            key = 'SURVEY_9';
            setAnswer({
                ...answer,
                divorceDt: "",
                divorceYn: "",
                 marTaxYn: "",
                [column]: value,
            })
        }
        else if(column === "householderYn"){
            key = 'SURVEY_117';
            setAnswer({
                ...answer,
                step_32: value,
                step_61: value,
                step_77: value,
                step_83: value,
                step_102: value,
                [column]: value,
            })
        }
        else if(column === "divorceYn"){
          key = 'SURVEY_120';
          setAnswer({
            ...answer,
            [column]: value,
          })
        }
        else if(column === "marTaxYn"){
          key = 'SURVEY_125';
          setAnswer({
            ...answer,
            [column]: value,
          })
        }
        else{
            setAnswer({
                ...answer,
                [column]: value,
            })
        }


        setSelectedMenuItem(key);
        setMenuCheck(value !== '');
    };


    const step9List = surveyData[9].text.map((item) => {
        // item.content = item.content.replace('$stdYear$', userInfo.stdYear);

        return (
            <>
                <FormControlLabel
                    key={'9-' + item.key}
                    name={String(item.toggle)}
                    value={item.key}
                    control={
                        <Radio
                            key={'survey-' + item.key}
                            disableRipple
                            color="default"
                            checked={answer['spouse'] === item.key}
                            onChange={(e) => handleInputAnswer(e, "spouse")}
                            checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)}/>}
                            icon={<span className={classes.icon}
                                        key='rd-step-9'
                                        onChange={(e) => handleInputAnswer(e, "spouse")}/>}
                            {...props}
                        />
                }
                        label={item.content}
                />
            </>
        )
    });

    const step120List = surveyData[120].text.map((item) => {
      return (
        <>
          <FormControlLabel
            key={'9-1-' + item.key}
            name={String(item.toggle)}
            value={item.key}
            control={
              <Radio
                key={'survey-' + item.key}
                disableRipple
                color="default"
                checked={answer['divorceYn'] === item.key}
                onChange={(e) => handleInputAnswer(e, "divorceYn")}
                checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)}/>}
                icon={<span className={classes.icon}
                            key='rd-step-120'
                            onChange={(e) => handleInputAnswer(e, "divorceYn")}/>}
                {...props}
              />
            }
            label={item.content}
          />
        </>
      )
    });

  const step125List = surveyData[125].text.map((item) => {
    return (
      <>
        <FormControlLabel
          key={'9-1-' + item.key}
          name={String(item.toggle)}
          value={item.key}
          control={
            <Radio
              key={'survey-' + item.key}
              disableRipple
              color="default"
              checked={answer['marTaxYn'] === item.key}
              onChange={(e) => handleInputAnswer(e, "marTaxYn")}
              checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)}/>}
              icon={<span className={classes.icon}
                          key='rd-step-125'
                          onChange={(e) => handleInputAnswer(e, "marTaxYn")}/>}
              {...props}
            />
          }
          label={item.content}
        />
      </>
    )
  });


    const step9_2List = surveyData[117].text.map((item) => {
        // item.content = item.content.replace('$stdYear$', userInfo.stdYear);

        return (
            <>
                <FormControlLabel
                    key={'9-2-' + item.key}
                    name={String(item.toggle)}
                    value={item.key}
                    control={
                    <Radio
                        key={'survey-' + item.key}
                        disableRipple
                        color="default"
                        onChange={(e) => handleInputAnswer(e, "householderYn")}
                        checked={answer['householderYn'] === item.key}
                        checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
                        icon={<span className={classes.icon} />}
                        {...props}
                    />}
                    label={item.content}
                />
            </>
        )
    });


    return (
        <>
            <ScrollableAnchor id={"9"}>
                <div>
                    <Container style={{background: 'transparent', marginBottom: '10px'}}>
                        <SentenceForm
                            title={surveyData[9].title}
                            sentences={surveyData[9].questions}
                            step={9}
                        />
                        <FormControl component="fieldset" style={{margin: '10px 20px 0 25px'}}>
                            <RadioGroup defaultValue="0" aria-label="" row>
                                {step9List}
                            </RadioGroup>
                        </FormControl>
                    </Container>
                    {visible &&
                      <>
                        <Container style={{background: 'transparent', marginBottom: '10px'}}>
                            <SentenceForm
                                title={surveyData[116].title}
                                sentences={surveyData[116].questions}
                                step={116}
                            />
                            <FormControl component="fieldset" style={{margin: '10px 20px 0 25px'}}>
                                <input
                                    className={classes.date}
                                    type="date"
                                    max="9999-12-31"
                                    value={divorceDt}
                                    name={"divorceDt"}
                                    onChange={(e) => handleInputAnswer(e, "divorceDt")}
                                />
                            </FormControl>
                        </Container>
                        <Container style={{background: 'transparent', marginBottom: '10px'}}>
                          <SentenceForm
                            title={surveyData[120].title}
                            sentences={surveyData[120].questions}
                            step={120}
                          />
                          <FormControl component="fieldset" style={{margin: '10px 20px 0 25px'}}>
                            <RadioGroup defaultValue="0" aria-label="" row>
                              {step120List}
                            </RadioGroup>
                          </FormControl>
                        </Container>
                      </>
                    }
                  {visibled02 &&
                  <>
                    <Container style={{background: 'transparent', marginBottom: '10px'}}>
                      <SentenceForm
                        title={surveyData[125].title}
                        sentences={surveyData[125].questions}
                        step={125}
                      />
                      <FormControl component="fieldset" style={{margin: '10px 20px 0 25px'}}>
                        <RadioGroup defaultValue="0" aria-label="" row>
                          {step125List}
                        </RadioGroup>
                      </FormControl>
                    </Container>
                  </>}
                    <Container style={{background: 'transparent', marginBottom: '10px'}}>
                        <SentenceForm
                            title={surveyData[117].title}
                            sentences={surveyData[117].questions}
                            step={117}
                        />
                        <FormControl component="fieldset" style={{margin: '10px 20px 0 25px'}}>
                            <RadioGroup defaultValue="0" aria-label="" name="" row>
                                {step9_2List}
                            </RadioGroup>
                        </FormControl>
                    </Container>
                </div>
            </ScrollableAnchor>
        </>
    );
};

export default Survey2;
